/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calculating_SyncInputs */

const en_calculating_sync = /** @type {(inputs: Calculating_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculating sync timing... please wait...`)
};

const fr_calculating_sync = /** @type {(inputs: Calculating_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcul du minutage de synchronisation... veuillez patienter...`)
};

const de_calculating_sync = /** @type {(inputs: Calculating_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Synchronisierungszeit wird berechnet... Bitte warten...`)
};

const it_calculating_sync = /** @type {(inputs: Calculating_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcolo del tempo di sincronizzazione... attendere prego...`)
};

const ru_calculating_sync = /** @type {(inputs: Calculating_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вычисление синхронизации... пожалуйста, подождите...`)
};

const es_calculating_sync = /** @type {(inputs: Calculating_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculando tiempo de sincronización... por favor espere...`)
};

const zh_cn2_calculating_sync = /** @type {(inputs: Calculating_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在计算同步时序……请稍候……`)
};

const ja_calculating_sync = /** @type {(inputs: Calculating_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`同期タイミングを計算しています...お待ちください...`)
};

const hi_calculating_sync = /** @type {(inputs: Calculating_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सिंक्रोनाइज़ेशन टाइमिंग की गणना की जा रही है... कृपया प्रतीक्षा करें...`)
};

const pt_pt2_calculating_sync = /** @type {(inputs: Calculating_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculando o tempo de sincronização... aguarde...`)
};

/**
* | output |
* | --- |
* | "Calculating sync timing... please wait..." |
*
* @param {Calculating_SyncInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const calculating_sync = /** @type {((inputs?: Calculating_SyncInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calculating_SyncInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_calculating_sync(inputs)
	if (locale === "de") return de_calculating_sync(inputs)
	if (locale === "it") return it_calculating_sync(inputs)
	if (locale === "ru") return ru_calculating_sync(inputs)
	if (locale === "es") return es_calculating_sync(inputs)
	if (locale === "zh-CN") return zh_cn2_calculating_sync(inputs)
	if (locale === "ja") return ja_calculating_sync(inputs)
	if (locale === "hi") return hi_calculating_sync(inputs)
	if (locale === "pt-PT") return pt_pt2_calculating_sync(inputs)
	return en_calculating_sync(inputs)
});